import { ManualUnitValues } from "../types/ManualUnitValues";

export const EMPTY_MANUAL_UNIT_VALUES: ManualUnitValues = {
  unitNumber: "",
  type: "Residential",
  phase: 1,
  fuseAmp: 60,
  supply: "Permanent",
};
